var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'DINPro-Condensed';\n  src: url(" + escape(require("./DINPro-Condensed/DINPro-Condensed-Bold.eot")) + ");\n  src: url(" + escape(require("./DINPro-Condensed/DINPro-Condensed-Bold.eot")) + "?#iefix) format('embedded-opentype'),\n  url(" + escape(require("./DINPro-Condensed/DINPro-Condensed-Bold.woff2")) + ") format('woff2'),\n  url(" + escape(require("./DINPro-Condensed/DINPro-Condensed-Bold.woff")) + ") format('woff'),\n  url(" + escape(require("./DINPro-Condensed/DINPro-Condensed-Bold.ttf")) + ") format('truetype');\n  font-weight: 700;\n  font-style: normal;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/fonts/DINPro-Condensed.css
// module id = 1568
// module chunks = 57